import React, { Component, InputHTMLAttributes } from "react";

import * as styles from "./Checkbox.scss";

export class Checkbox extends Component<InputHTMLAttributes<HTMLInputElement>> {
    public render() {
        return (
            <input
                type="checkbox"
                className={styles.checkbox}
                {...this.props}
            />
        );
    }
}
